import { render, staticRenderFns } from "./ResumationDialog.vue?vue&type=template&id=5c886c1a&"
import script from "./ResumationDialog.vue?vue&type=script&lang=js&"
export * from "./ResumationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports